import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShop = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "shop" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,12.75v9a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5v-9"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.148.75H2.852a.751.751,0,0,0-.733.587L.75,7.5a2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0L21.88,1.337A.749.749,0,0,0,21.148.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 17.25,
			x2: 15,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15,
			y1: 23.25,
			x2: 15,
			y2: 12.75
		})
	]
});
export default SvgShop;
